import type { SVGProps } from 'react';

const SvgPricing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="pricing">
      <path d="M16 .35A15.68 15.68 0 1 0 31.68 16 15.69 15.69 0 0 0 16 .35m0 29.86A14.18 14.18 0 1 1 30.18 16 14.19 14.19 0 0 1 16 30.21" />
      <path d="M17.43 10.07h-.68V8h-1.5v2h-.55a3.36 3.36 0 0 0 0 6.71h.55v3.79h-.68a1.7 1.7 0 0 1-1.7-1.7h-1.5a3.21 3.21 0 0 0 3.2 3.2h.68v2h1.5v-2h.55a3.36 3.36 0 0 0 0-6.72h-.55v-3.71h.68a1.7 1.7 0 0 1 1.7 1.69v.44h1.5v-.44a3.2 3.2 0 0 0-3.2-3.19m-.13 6.71a1.86 1.86 0 0 1 0 3.72h-.55v-3.72Zm-2.05-1.5h-.55a1.86 1.86 0 0 1 0-3.71h.55Z" />
    </g>
  </svg>
);

export default SvgPricing;
